/**
 * Shared utilities entry point
 *
 * Components should import directly for better security and encapsulation:
 *   import eventBus from '../shared/events.js'
 *   import { debounce } from '../shared/utils.js'
 *
 * Also exposed globally as window.FelixShared for backward compatibility
 * and non-module code (e.g., inline scripts, third-party integrations).
 *
 * @package Felix
 */

import eventBus from './events.js'
import state from './state.js'
import * as utils from './utils.js'
import * as clampToggles from './clamp-toggle.js'

window.FelixShared = {
	eventBus,
	state,
	utils,
	clampToggles,
}

export { eventBus, state, utils, clampToggles }
